export default __webpack_public_path__ + "eecde083e6a4eb1606d12231ea4be0fb.png";